import { z } from 'zod';
/** Who a broadcast targets:
 *  - `all`           — every user who ever opened the bot (legacy behaviour)
 *  - `joined_within` — users whose account was created in the last `days`
 *  - `users`         — an explicit, admin-picked set of user ids */
export const broadcastAudienceSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal('all') }),
    z.object({ type: z.literal('joined_within'), days: z.number().int().min(1).max(365) }),
    z.object({ type: z.literal('users'), userIds: z.array(z.string().min(1)).min(1).max(1000) }),
]);
export const createBroadcastSchema = z.object({
    text: z.string().trim().min(1, 'Минимум 1 символ').max(4000),
    // Defaulting to `all` keeps older clients / direct API calls working.
    audience: broadcastAudienceSchema.default({ type: 'all' }),
});
/** Body for the "how many will this reach?" preview check. */
export const broadcastPreviewSchema = z.object({
    audience: broadcastAudienceSchema.default({ type: 'all' }),
});
export const broadcastPreviewResultSchema = z.object({
    count: z.number().int(),
});
export const broadcastResultSchema = z.object({
    id: z.string(),
    total: z.number().int(),
    sent: z.number().int(),
    failed: z.number().int(),
});
